import capitalize from 'lodash/capitalize'

export type Props = {
  kind: 'rooms' | 'bedrooms' | 'bathroom'
}

const PropertyIcon: React.FC<Props> = (props) => {
  const iconComponentName = capitalize(props.kind)
  const Icon = require(`@/components/Icon`).default[iconComponentName]

  return <Icon height={12} width={12} />
}

export default PropertyIcon
